import React, { useEffect, useRef, useState } from 'react';
import { type PresentationFrame } from '../controllers/PresentationController';
import styles from './presentations.module.css';

interface FrameThumbnailProps {
  frame: PresentationFrame;
}
const FrameThumbnail: React.FC<FrameThumbnailProps> = ({ frame }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (wrapperRef.current) {
      let timer: ReturnType<typeof setTimeout> | undefined;

      const root = wrapperRef.current.closest(
        '.sidepanel-scroll-parent, .presentation-sidepanel-scroll-component'
      );

      const observer = new IntersectionObserver(
        ([entry]) => {
          clearTimeout(timer);
          timer = setTimeout(() => {
            setShouldRender(entry.isIntersecting);
          }, 500);
        },
        {
          root,
          // render thumbs adjacent to the visible ones, so they aren't blank when scrolled into view
          rootMargin: '100%',
        }
      );
      observer.observe(wrapperRef.current);
      return () => {
        clearTimeout(timer);
        observer.disconnect();
      };
    }
  }, []);

  const thumbnail = shouldRender ? frame.getThumbnail() : undefined;

  return (
    <div ref={wrapperRef} className={styles.imageWrapper}>
      {thumbnail ? (
        <img src={thumbnail.src} alt={`${frame.getName()} thumbnail`} />
      ) : (
        <span className={styles.imagePlaceholder} />
      )}
    </div>
  );
};

export default FrameThumbnail;
